export default "__VITE_ASSET__2vD$Gvtd__"